import { SEARCH_PARAMS_FILTERS } from '../constants/searchParamsFilters';
import { useSearchParams } from 'react-router-dom';
import { PartnerDetail } from '../types/types';
import { modifySearchParamsForId } from '../utils/filters';
import FilterPartnerContent from './FilterPartnerContent';

const FilterPartner: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedPartners = searchParams.get(SEARCH_PARAMS_FILTERS.PARTNER_PARAM) || '';

  const handlePartnerClick = (partner: PartnerDetail) => {
    const alteredSearchParams = modifySearchParamsForId(
      searchParams,
      selectedPartners,
      partner.id,
      SEARCH_PARAMS_FILTERS.PARTNER_PARAM
    );
    setSearchParams(alteredSearchParams);
  };

  return <FilterPartnerContent selectedPartners={selectedPartners} handlePartnerClick={handlePartnerClick} />;
};

export default FilterPartner;
